import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexGeneral',
  setup(__props) {

const currencyWidget1 = defineAsyncComponent(() => import("@/components/theme/widgets/general/currencyWidget1.vue"))
const currencyWidget2 = defineAsyncComponent(() => import("@/components/theme/widgets/general/currencyWidget2.vue"))
const currencyWidget3 = defineAsyncComponent(() => import("@/components/theme/widgets/general/currencyWidget3.vue"))
const salesPer = defineAsyncComponent(() => import("@/components/theme/widgets/general/salesPer.vue"))
const profitPer = defineAsyncComponent(() => import("@/components/theme/widgets/general/profitPer.vue"))
const widgetCard = defineAsyncComponent(() => import("@/components/theme/widgets/general/widgetCard.vue"))
const courseWidget = defineAsyncComponent(() => import("@/components/theme/widgets/general/courseWidget.vue"))
const totalUsers = defineAsyncComponent(() => import("@/components/theme/widgets/general/totalUsers.vue"))
const visitorChart = defineAsyncComponent(() => import("@/components/theme/widgets/general/visitorChart.vue"))
const radialFacebook = defineAsyncComponent(() => import("@/components/theme/widgets/general/radialFacebook.vue"))
const radialTwitter = defineAsyncComponent(() => import("@/components/theme/widgets/general/radialTwitter.vue"))
const radialInstagram = defineAsyncComponent(() => import("@/components/theme/widgets/general/radialInstagram.vue"))
const radialYoutube = defineAsyncComponent(() => import("@/components/theme/widgets/general/radialYoutube.vue"))
const smallWidget = defineAsyncComponent(() => import("@/components/theme/widgets/general/smallWidget.vue"))
const balanceProfile = defineAsyncComponent(() => import("@/components/theme/widgets/general/balanceProfile.vue"))
const calenderView = defineAsyncComponent(() => import("@/components/theme/widgets/general/calenderView.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Widgets",
      title: "General"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(currencyWidget1)),
        _createVNode(_unref(currencyWidget2)),
        _createVNode(_unref(currencyWidget3)),
        _createVNode(_unref(salesPer)),
        _createVNode(_unref(profitPer)),
        _createVNode(_unref(widgetCard)),
        _createVNode(_unref(courseWidget)),
        _createVNode(_unref(totalUsers)),
        _createVNode(_unref(visitorChart)),
        _createVNode(_unref(radialFacebook)),
        _createVNode(_unref(radialTwitter)),
        _createVNode(_unref(radialInstagram)),
        _createVNode(_unref(radialYoutube)),
        _createVNode(_unref(smallWidget)),
        _createVNode(_unref(balanceProfile)),
        _createVNode(_unref(calenderView))
      ])
    ])
  ], 64))
}
}

})